import axios from "axios";
import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import logo from '../../assets/HAUTIER-logo.png';
import Title from '../Containers/Title';

export default function Register() {

    const [email, setEmail] = useState('');
    const [password, setpassword] = useState('');
    const [rePassword, setrePassword] = useState('');
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const onChangeEmail = (e) => {
        const email = e.target.value;
        setEmail(email);
    };
    const onChangePassword = (e) => {
        const password = e.target.value;
        setpassword(password);
    };
    const onChangeRePassword = (e) => {
        const rePassword = e.target.value;
        setrePassword(rePassword);
    };

    const handleLogin = () => {

        const loginData = {
          "email": email,
          "password": password,
          "password_confirm": rePassword
        }
        
        const api = axios.create({
          baseURL: `https://api.hautier-transports.fr/crm/`
        })
    
        api.post("/auth/signUp", loginData)
        
            .then(res => {           
              setMessage(res)
              alert("Votre nom d'utilisateur est désormais : "+ res.data.login)
              
            })
            .then(res => {             
                navigate("/login");
          })
            .catch(error=>{
                alert("Problème lors de la création du compte veuillez contacter l'administrateur")
                setMessage("Auth failure! Please create an account");
            })
    };

    return (
        <div className="relative flex flex-col justify-center min-h-screen overflow-hidden">
            
            <div>
                <img className="w-[20%]" src={logo} />
            </div>
            <div className="w-full p-6 m-auto bg-white -mt-2  lg:max-w-xl">
                <Title title="Inscription"/>
                <form  className="mt-6" onSubmit={handleLogin}>
                    <div className="mb-2">
                        <label
                            className="block text-sm font-semibold text-grey"
                        >
                            Adresse email
                        </label>
                        <input
                            type="text"
                            name="login"
                            className="block w-full px-4 py-2 mt-2 text-marineLogo bg-white border rounded-md focus:border-purple-400 focus:ring-bleu200 focus:outline-none focus:ring focus:ring-opacity-40"
                            value={email} 
                            onChange={onChangeEmail}
                        />
                    </div>
                    <div className="mb-2">
                        <label
                            className="block text-sm font-semibold text-grey"
                        >
                            Mot de passe
                        </label>
                        <input
                            type="password"
                            name="password"
                            className="block w-full px-4 py-2 mt-2 text-marineLogo bg-white border rounded-md focus:border-marineLogo focus:ring-bleu200 focus:outline-none focus:ring focus:ring-opacity-40"
                            value={password}
                            onChange={onChangePassword}
                        />
                    </div>
                    <div className="mb-2">
                        <label
                            className="block text-sm font-semibold text-grey"
                        >
                            Confirmation du mot de passe
                        </label>
                        <input
                            type="password"
                            name="password"
                            className="block w-full px-4 py-2 mt-2 text-marineLogo bg-white border rounded-md focus:border-marineLogo focus:ring-bleu200 focus:outline-none focus:ring focus:ring-opacity-40"
                            value={rePassword}
                            onChange={onChangeRePassword}
                        />
                    </div>
                    <div className="mt-6">
                        <button 
                            type="button" 
                            className="w-full px-4 py-2 tracking-wide text-blanc transition-colors duration-200 transform bg-vertLogo rounded-md hover:border hover:bg-blanc hover:text-vertLogo hover:border-vertLogo focus:outline-none focus:bg-blanc focus:text-vertLogo"
                            onClick={handleLogin}
                        >
                            Inscription
                        </button>
                    </div>
                </form>

                <p className="mt-8 text-xs font-light text-center text-grey">
                    {" "}
                    Déjà un compte?{" "}
                    <Link
                        to="/login"
                        className="font-medium text-marineLogo hover:underline"
                    >
                        Se connecter
                    </Link>
                </p>
            </div>
        </div>
    );
}